import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface AdminUser {
  id: number
  email: string
  name: string
  role: 'SUPER_ADMIN' | 'ADMIN' | 'VIEWER'
  /** Preferred UI language from ThinkClass account (en | es). */
  language?: 'en' | 'es' | string
}

interface AuthState {
  user: AdminUser | null
  token: string | null
  isAuthenticated: boolean
  isLoading: boolean
}

const TOKEN_KEY = 'admin_token'
const USER_KEY = 'admin_user'

function readStoredUser(): AdminUser | null {
  try {
    const raw = localStorage.getItem(USER_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed.id === 'number' && parsed.email && parsed.role) {
      return parsed as AdminUser
    }
  } catch {
    /* ignore */
  }
  return null
}

const token = localStorage.getItem(TOKEN_KEY)
const storedUser = token ? readStoredUser() : null

const initialState: AuthState = {
  user: storedUser,
  token: token,
  isAuthenticated: !!token,
  isLoading: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<{ user: AdminUser; token: string }>) => {
      const { user, token } = action.payload
      state.user = user
      state.token = token
      state.isAuthenticated = true
      localStorage.setItem(TOKEN_KEY, token)
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    logout: (state) => {
      state.user = null
      state.token = null
      state.isAuthenticated = false
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(USER_KEY)
      try {
        localStorage.removeItem('school_admin_lang_manual')
      } catch {
        /* ignore */
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
  },
})

export const { setCredentials, logout, setLoading } = authSlice.actions
export default authSlice.reducer
